/// FOURJS_START_COPYRIGHT(D,2014)
/// Property of Four Js*
/// (c) Copyright Four Js 2014, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("FormFieldNode", ["NodeBase", "NodeFactory"], function (context, cls) {
  /**
   * @class FormFieldNode
   * @memberOf classes
   * @extends classes.NodeBase
   */
  class FormFieldNode extends cls.NodeBase /** @lends classes.FormFieldNode.prototype */ {
    /**
     * @inheritDoc
     */
    _createController() {
      const decoratorNode = this._children[0];
      const controllerType = decoratorNode?._tag;
      return cls.ControllerFactory.create(controllerType, {
        anchor: this,
        parent: this._parent,
        ui: this.getApplication().getNode(0),
        decorator: decoratorNode,
        container: this,
        form: this.getAncestor("Form")
      });
    }
    /**
     * @inheritDoc
     */
    _createChildrenControllers(_queue) {
      // Intentionally empty: overrides NodeBase to prevent creating children controllers
    }

    /**
     * @inheritDoc
     */
    getStyleAttribute(styleAttr, forcedPseudoSelectors) {
      // On FormFields, take the decorator node into account
      const decoratorNode = this.getChildren()[0];
      const pseudoSelectors = forcedPseudoSelectors || this._computePseudoSelectors();
      return decoratorNode._getStyleAttributeImpl(styleAttr, pseudoSelectors);
    }
  }
  cls.FormFieldNode = FormFieldNode;
  cls.NodeFactory.register("FormField", cls.FormFieldNode);
});
